import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import ChainSettingsMenuV2 from './components/ChainSettingsMenuV2';
import SettingsChainInfoV2 from './components/SettingsChainInfoV2';
import SettingsChainPermissionsV2 from './components/SettingsChainPermissionsV2';
import SettingsChainMembershipsV2 from './components/SettingsChainMembershipsV2';
import SettingsChainCareServicesV2 from './components/SettingsChainCareServicesV2';
import SettingsChainInvoiceV2 from './components/SettingsChainInvoiceV2';
import SettingsChainNetvisorV2 from './components/SettingsChainNetvisorV2';
import SettingsChainAuditLogV2 from './components/SettingsChainAuditLogV2';
import SettingsChainCustomerVehiclesV2 from './components/SettingsChainCustomerVehiclesV2';
import NotificationSettingsView from '../NotificationSettings/NotificationSettingsView';
import {
  fetchChain as _fetchChain,
  fetchChainPermissions as _fetchChainPermissions,
  fetchChainMemberships as _fetchChainMemberships,
  fetchChainCareServices as _fetchChainCareServices,
  fetchChainCareServiceInvitations as _fetchChainCareServiceInvitations,
  fetchChainInvoiceSettings as _fetchChainInvoiceSettings,
  fetchChainNetvisorSettings as _fetchChainNetvisorSettings,
} from '../../actions/chainActions';
import { T } from './components/chainSettingsV2Styles';

class ChainSettingsViewV2 extends React.Component {
  componentWillMount() {
    document.documentElement.classList.add('settings-bg');
  }

  componentDidMount() {
    const {
      selectedChainId,
      fetchChain,
      fetchChainPermissions,
      fetchChainMemberships,
      fetchChainCareServices,
      fetchChainCareServiceInvitations,
    } = this.props;

    if (selectedChainId) {
      fetchChain(selectedChainId);
      fetchChainPermissions(selectedChainId);
      fetchChainMemberships(selectedChainId);
      fetchChainCareServices(selectedChainId);
      fetchChainCareServiceInvitations(selectedChainId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      selectedChainId,
      fetchChain,
      fetchChainPermissions,
      fetchChainMemberships,
      fetchChainCareServices,
      fetchChainCareServiceInvitations,
    } = this.props;

    if (selectedChainId && selectedChainId !== prevProps.selectedChainId) {
      fetchChain(selectedChainId);
      fetchChainPermissions(selectedChainId);
      fetchChainMemberships(selectedChainId);
      fetchChainCareServices(selectedChainId);
      fetchChainCareServiceInvitations(selectedChainId);
    }
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('settings-bg');
  }

  render() {
    const { t, user, selectedChainId, chains } = this.props;

    var currentChain = chains && chains.find(function (c) {
      return c.id == selectedChainId;
    });
    if (!currentChain && user && user.chains) {
      currentChain = user.chains.find(function (c) {
        return c.id == selectedChainId;
      });
    }
    const useConsolidatedInvoicing = currentChain && currentChain.use_consolidated_invoicing;

    var userChainData = user && user.chains && user.chains.find(function (c) {
      return c.id == selectedChainId;
    });
    var userRole = userChainData && userChainData.user_role ? userChainData.user_role : null;
    var isAdmin = userRole === 'admin';
    var isAdminOrManager = userRole === 'admin' || userRole === 'manager';

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'outerContainer')}>
            <div style={getStyle(screenSize, styles, 'innerContainer')}>
              <h1 style={getStyle(screenSize, styles, 'heading')}>
                <i className="pi pi-cog" style={{ marginRight: 12, opacity: 0.7, fontSize: 22 }} />
                {t('chainSettingsHeading')}
              </h1>

              {screenSize !== 'large' && (
                <div style={{ marginBottom: 16 }}>
                  <ChainSettingsMenuV2 user={user} selectedChainId={selectedChainId} chain={currentChain} userRole={userRole} />
                </div>
              )}

              <div style={getStyle(screenSize, styles, 'layout')}>
                {screenSize === 'large' && (
                  <div style={getStyle(screenSize, styles, 'sidebar')}>
                    <ChainSettingsMenuV2 user={user} selectedChainId={selectedChainId} chain={currentChain} userRole={userRole} />
                  </div>
                )}
                <div style={getStyle(screenSize, styles, 'content')}>
                  <Route exact path="/chain-settings/" render={function () { return <SettingsChainInfoV2 chain={currentChain} userRole={userRole} />; }} />
                  <Route exact path="/chain-settings/info" render={function () { return <SettingsChainInfoV2 chain={currentChain} userRole={userRole} />; }} />
                  <Route exact path="/chain-settings/notifications" render={function () { return <NotificationSettingsView compact />; }} />
                  {isAdmin && (
                    <Route exact path="/chain-settings/permissions" render={function () { return <SettingsChainPermissionsV2 chainId={selectedChainId} />; }} />
                  )}
                  {isAdmin && (
                    <Route exact path="/chain-settings/memberships" render={function () { return <SettingsChainMembershipsV2 chainId={selectedChainId} />; }} />
                  )}
                  {isAdminOrManager && (
                    <Route exact path="/chain-settings/care-services" render={function () { return <SettingsChainCareServicesV2 chainId={selectedChainId} />; }} />
                  )}
                  {useConsolidatedInvoicing && isAdminOrManager && (
                    <Route exact path="/chain-settings/invoice" render={function () { return <SettingsChainInvoiceV2 chainId={selectedChainId} />; }} />
                  )}
                  {useConsolidatedInvoicing && isAdmin && (
                    <Route exact path="/chain-settings/netvisor" render={function () { return <SettingsChainNetvisorV2 chainId={selectedChainId} />; }} />
                  )}
                  {isAdminOrManager && (
                    <Route exact path="/chain-settings/customer-vehicles" render={function () { return <SettingsChainCustomerVehiclesV2 chainId={selectedChainId} />; }} />
                  )}
                  {isAdminOrManager && (
                    <Route exact path="/chain-settings/audit-log" render={function () { return <SettingsChainAuditLogV2 chainId={selectedChainId} />; }} />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    outerContainer: {
      background: T.bgGradient,
      position: 'absolute',
      left: 0,
      top: 50,
      bottom: 0,
      right: 0,
      overflowY: 'auto',
    },
    innerContainer: {
      maxWidth: 1140,
      margin: '0 auto',
      padding: '32px 40px',
    },
    heading: {
      color: T.textPrimary,
      fontSize: 24,
      fontWeight: 600,
      marginBottom: 28,
      display: 'flex',
      alignItems: 'center',
    },
    layout: {
      display: 'flex',
      gap: 28,
      alignItems: 'flex-start',
    },
    sidebar: {
      width: 240,
      flexShrink: 0,
      position: 'sticky',
      top: 32,
    },
    content: {
      flex: 1,
      minWidth: 0,
    },
  },
  medium: {
    innerContainer: {
      padding: '20px 16px',
    },
    heading: {
      fontSize: 20,
      marginBottom: 20,
    },
    layout: {
      flexDirection: 'column',
      gap: 0,
    },
    content: {
      width: '100%',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    selectedChainId: state.chain.selectedChainId,
    chains: state.chain.chains,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChain: _fetchChain,
    fetchChainPermissions: _fetchChainPermissions,
    fetchChainMemberships: _fetchChainMemberships,
    fetchChainCareServices: _fetchChainCareServices,
    fetchChainCareServiceInvitations: _fetchChainCareServiceInvitations,
    fetchChainInvoiceSettings: _fetchChainInvoiceSettings,
    fetchChainNetvisorSettings: _fetchChainNetvisorSettings,
  },
)(translate('ChainSettingsView')(ChainSettingsViewV2));
